export default function WorkshopEvent({
    title,
    imgSrc,
    location,
    eventDate,
    eventCost,
    link
}) {
    const date = new Date(eventDate);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });

    return (
        <div className="col-lg-4 col-sm-6 mb-5 mb-lg-0" style={{ padding: "20px" }}>
            <div className="card border-0 rounded-0 hover-shadow">

                <div className="card-img position-relative">
                    <img className="card-img-top rounded-0" src={imgSrc} alt={title} />

                    <div className="card-date h5">
                        <span>{day}</span>
                        <br />
                        {month}
                    </div>
                </div>

                <div className="card-body">
                    <h4 className="card-title h4 text-secondary">
                        {title}
                    </h4>

                    <p>
                        <i className="ti-location-pin text-primary mr-2" />
                        {location}
                        <br />
                        <i className="ti-ticket text-primary mr-2" />
                        {eventCost ? (isNaN(eventCost) ? eventCost : `$${eventCost}`) : ""}
                    </p>

                    {link && (
                        <div className="btn-center">
                            <a
                                href={`#/events/${link}`}
                                className="btn btn-primary btn-sm"
                            >
                                Details
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}